var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page_box"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}}),(_vm.textFlag)?_c('div',{staticClass:"bannerTitleBox",attrs:{"id":"bigBox"}},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bannerTitle"},[_c('h1',[_vm._v("润信数字智能科技")]),_c('p',[_vm._v("AI赋能千行百业")]),_c('button',[_vm._v("立即查看")])])
}]

export { render, staticRenderFns }